<template>
  <section class="content-block ie-fix">
    <transition name="slide-fade">
      <div
        v-if="active"
        class="block has-white-background"
      >
        <div class="inner-block is-flex">
          <div
            class="has-mobile-adj"
            :class="$store.state.reservationType === 2 ? 'fahrt-full' : 'col-2'"
          >
            <h1 class="title">
              {{ $t("fahrtView.label.tourType") }}
            </h1>
            <div class="select">
              <select
                v-model="$store.state.selectedType"
                @change="checkTypeDate()"
              >
                <option
                  v-for="(option, i) in options_Type"
                  :key="i"
                  :disabled="option.disabled"
                  :value="option.request"
                >
                  {{ option.text }} {{ (option.disabled) ? $t("fahrtView.label.reservationNotNecessaryHint") : "" }}
                </option>
              </select>
            </div>
          </div>
          <div
            :class="$store.state.reservationType === 2 ? 'fahrt-full' : 'col-2'"
            :key="updateCalendar"
          >
            <h1 class="title">
              {{ $t("general.label.date") }}
            </h1>
            <p
              v-scroll-to="'#datepicker'"
              class="control has-icons-right"
              id="datepicker"
            >
              <datepicker
                :placeholder="$t('general.label.selectDate')"
                :input-class="'input'"
                :minimum-view="minimumView"
                :maximum-view="maximumView"
                :format="format"
                :language="language"
                :full-month-name="true"
                :monday-first="true"
                v-model="$store.state.selectedDate"
                :highlighted="highlighted_dates"
                @input="fetch_GET_Fn()"
                :disabled-dates="disabledDates"
                :inline="$store.state.reservationType === 2"
              >
                <template #day="props">
                  <span
                    v-if="$store.state.dynamicPrices && $store.state.reservationType === 2"
                    class="slot-day"
                    :class="calendarPriceClasses($store.state.dynamicPrices[props.date])"
                  >
                    {{ props.day }}
                    <span
                      class="cell-price"
                      v-if="$store.state.dynamicPrices[props.date]"
                    >
                      <template v-if="$store.state.dynamicPrices[props.date].dynamicPrice">
                        € {{ $store.state.dynamicPrices[props.date].dynamicPrice.toFixed(2).replace('.', ',') }}
                      </template>
                      <template v-else>
                        € {{ $store.state.dynamicPrices[props.date].price.toFixed(2).replace('.', ',') }}
                      </template>
                    </span>
                  </span>
                </template>
              </datepicker>
              <span class="icon is-small is-right"><font-awesome-icon icon="calendar-alt"/></span>
            </p>
          </div>
          <div v-if="$store.state.fahrttyp === 'ascent'">
            <p class="input-note">
              {{ $t("fahrtView.label.reservationNotNecessaryAfter") }}
            </p>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import {liveURL} from '../../api-config';
import moment from 'moment'

import axios from 'axios'
import Datepicker from '@/components/vuejs-datepicker';
import {de} from 'vuejs-datepicker/dist/locale';
import {en} from 'vuejs-datepicker/dist/locale';
import {sequencePairs} from "@/store";

export default {
  name: 'FahrtAuswahl',
  components: {
    Datepicker
  },
  data() {
    return {
      active: false,
      updateCalendar: 0,
      highlighted_dates: {
        dates: [
          new Date()
        ]
      },
      options_Type: [
        {text: this.$t("general.label.tourAscentDescent"), request: '1', disabled: false},
        {text: this.$t("sequenceLabels.tour.1"), request: '2', disabled: false},
        {text: this.$t("sequenceLabels.tour.3"), request: '3', disabled: false}
      ],
      format: 'MMMM yyyy',
      minimumView: 'day',
      maximumView: 'day',
      language: this.$t('general.settings.currentLanguageCode') === 'de' ? de : en, // Todo: Find better way to get languageObject :)
      highlighted: {
        customPredictor: function (date) {
          // highlights the date if it is a multiple of 4
          if (date.getDate() % 4 == 0) {
            return true
          }
        }
      }
    }
  },
  computed: {
    disabledDates: function () {
      return {
        to: this.$store.state.selectedType === "5"
          ? new Date('2026-05-01')
          : this.$store.state.selectedType === "7"
            ? new Date('2026-09-01')
            : this.$store.state.eventSequence === "15"
              ? new Date('2025-12-01')
              : new Date('2026-05-09'), // Berg & Tahlfahrt
        from: this.$store.state.selectedType === "5"
          ? new Date('2026-08-01')
          : this.$store.state.selectedType === "7"
            ? new Date('2026-10-01')
            : this.$store.state.eventSequence === "15" // HD-23964
              ? new Date('2026-04-01')
              : new Date('2026-11-09'), // Berg & Tahlfahrt
      }
    }
  },
  watch: {},
  mounted() {
    if (!this.$store.state.selectedDate) {
      this.$store.state.selectedType = 1;
    }
    const start = this.$store.state.selectedType === "5"
      ? new Date('2026-05-01')
      : this.$store.state.selectedType === "7"
        ? new Date('2026-09-01')
        : this.$store.state.eventSequence === "15" // HD-23964
          ? new Date('2025-12-01')
          : new Date('2026-05-09'); // Berg & Tahlfahrt
    const today = new Date();
    this.$store.state.selectedDate = today > start ? today : start;
    this.active = true;

    // for testing:
    // http://localhost:8080/templates/dac/t1/module/reservation/?eventSequence=5 (=7)

    // id 1 / type 2 - bergfahrt
    // id 3 / type 3 - talfahrt
    // id 5 / type 4 - sonnenaufgang
    // id 7 / type 5 - sonnenuntergang
    // id 10 / type 6 - fondue
    // id 11 / type 7 - breakfast

    // set tourtype
    if (!this.$store.state.eventSequence || [1, 3].includes(this.$store.state.eventSequence)) {
      this.$store.state.fahrttyp = 'default';
      this.format = 'dd. MMMM yyyy';
      this.minimumView = 'day';
      this.maximumView = 'day';
    } else {
      this.$store.state.fahrttyp = 'subset';
      this.format = 'MMMM yyyy';
      this.minimumView = 'month';
      this.maximumView = 'month';
    }

    // set selected eventSequence
    if (this.$store.state.eventSequence) {
      switch (this.$store.state.eventSequence) {
        case '1':
          this.$store.state.selectedType = '2';
          break;
        case '3':
          this.$store.state.selectedType = '3';
          break;
        default:
          this.$store.state.selectedType = this.$store.state.eventSequence;
          break;
      }
    }
    this.$store.state.dynamicPrices = null;
    this.fetch_GET_Fn(true)
  },
  destroyed() {
  },
  methods: {
    checkTypeDate() {
      if (this.$store.state.selectedDate < this.disabledDates.to || this.$store.state.selectedDate > this.disabledDates.from) {
        const today = new Date();
        this.$store.state.selectedDate = today < this.disabledDates.to || today > this.disabledDates.from ? this.disabledDates.to : today;
      }
      this.fetch_GET_Fn(true);
    },
    calendarPriceClasses(p) {
      if (p && p.dynamicPrice && p.dynamicPrice < p.price) {
        if (p.dynamicPrice >= p.price * 0.94) return 'cheap'
        if (p.dynamicPrice >= p.price * 0.92) return 'veryCheap'
        return 'extremelyCheap';
      }
      return '';
    },
    fetch_GET_Fn(fetchPrices = false) {
      this.$store.state.bergfahrt_EventDate_ID = null;
      this.$store.state.talfahrt_EventDate_ID = null;
      this.$store.state.subset_EventDate_ID = null;
      this.$store.state.bergfahrt_Slot_ID = null;
      this.$store.state.talfahrt_Slot_ID = null;
      this.$store.state.subset_Slot_ID = null;
      this.$store.state.isLoading = true;

      if (this.$store.state.fahrttyp === 'default') {

        if (fetchPrices) {

          const dynamicPriceId = {
            1: 43,
            2: 31,
            3: 55
          }
          if (dynamicPriceId[this.$store.state.selectedType]) {
            const url = liveURL + '/api/smartPricer/calendar/getPrices';
            const today = new Date();
            let start = new Date('2026-05-09'); // Berg & Tahlfahrt
            if (today > start) {
              start = today;
            }
            const end = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate());
            axios.post(url, {
              productId: dynamicPriceId[this.$store.state.selectedType],
              start: moment(start).format('YYYY-MM-DD'),
              end: moment(end).format('YYYY-MM-DD'),
            }).then((response) => {
              this.$store.state.dynamicPrices = response.data;
              this.updateCalendar++;
            });
          }
        }

        this.fetch_GET();
        this.options_Type = [
          {text: this.$t("general.label.tourAscentDescent"), request: '1', disabled: false},
          {text: this.$t("sequenceLabels.tour.1"), request: '2', disabled: false},
          {text: this.$t("sequenceLabels.tour.3"), request: '3', disabled: false}
        ]
      }
      if (this.$store.state.fahrttyp === 'subset') {
        this.fetch_GET(true);
        this.options_Type = [];
        for (const id of sequencePairs.find(g => g.includes(this.$store.state.eventSequence))) {
          this.options_Type.push({text: this.$t("sequenceLabels.tour." + id), request: id, disabled: false})
        }
      }
    },
    fetch_GET(subset = false) {

      const time1 = subset
        ? moment(this.$store.state.selectedDate).startOf('month').format('YYYY-MM-DD')
        : moment(this.$store.state.selectedDate).format('YYYY-MM-DD');

      const time2 = subset
        ? moment(this.$store.state.selectedDate).endOf('month').add(1, 'days').format('YYYY-MM-DD')
        : moment(this.$store.state.selectedDate).add(1, 'days').format('YYYY-MM-DD');

      // sunrise fetches all slots from start of this month to start of next month,
      // while ascent/descent fetches all slots for today
      const time2key = subset ? 'startTime' : 'endTime';
      const sequenceSets = {
        1: [[1, 'Bergfahrt'], [3, 'Talfahrt']],
        2: [[1, 'Bergfahrt']],
        3: [[3, 'Talfahrt']]
      }

      const sets = this.$store.state.selectedType > 3 ?
        [[this.$store.state.selectedType, 'subset']]
        : sequenceSets[this.$store.state.selectedType];

      for (const seq of sets) {
        const url = liveURL + `/api/ticket/slot?eventSequenceId=${seq[0]}&q=gt(startTime,${time1})lt(${time2key},${time2})`;
        axios.get(url, {})
          .then(function (response) {
            this.$store.state[`fetch_GET_Content_${seq[1]}`] = response.data;
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });
      }

      this.$store.state.isLoading = false;
    }
  }
}
</script>

<style lang="scss">
.input-note {
  margin-top: 20px;
}

.fahrt-full {
  width: 100%;
  margin-bottom: 20px;

  .vdp-datepicker > .vdp-datepicker__calendar {
    width: 100%;

    header .next, header .prev, .cell {
      border-radius: 30px !important;
      height: 55px;
    }

    .cell {
      &:not(.selected) > .slot-day {
        &.cheap > .cell-price {
          color: #A9D08E;
        }

        &.veryCheap > .cell-price {
          color: #92D050;
        }

        &.extremelyCheap > .cell-price {
          color: #00B050;
        }


        &.expensive > .cell-price {
          color: #aa3333;
        }
      }

      .cell-price {
        font-size: 14px;
        display: block;
        margin-top: -8px;
        line-height: 1em;
      }

      @media screen and (max-width: 500px) {
        padding: 0 3px;
        .cell-price {
          font-size: 10px;
        }
      }
    }
  }
}
</style>
